import { render, staticRenderFns } from "./_Badge.vue?vue&type=template&id=956610a2"
import script from "./_Badge.vue?vue&type=script&lang=js"
export * from "./_Badge.vue?vue&type=script&lang=js"
import style0 from "./_Badge.vue?vue&type=style&index=0&id=956610a2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports